module.exports = __webpack_public_path__ + "static/media/logoCienytech.4447ac5f.png";